/**
 * Verifica se o Backtrack está habilitado via variável de ambiente.
 * Ativo apenas em desenvolvimento local e nos domínios de PR, com opt-in explícito.
 * Suporta REACT_APP_BACKTRACK e o legado REACT_APP_FLIGHT_RECORDER para retrocompatibilidade.
 */
export function isBacktrackEnabled(): boolean {
  const isFlagActive =
    process.env.REACT_APP_BACKTRACK === 'true' ||
    process.env.REACT_APP_FLIGHT_RECORDER === 'true';

  if (!isFlagActive) {
    return false;
  }

  // Trava de segurança estrita: nunca executa se o ambiente for explicitamente produção
  if (process.env.REACT_APP_ENV === 'production') {
    return false;
  }

  if (typeof window === 'undefined') return false;

  const hostname = window.location.hostname;
  if (process.env.NODE_ENV === 'development') {
    return ['localhost', '127.0.0.1', '[::1]', '0.0.0.0'].includes(hostname);
  }

  // O hostname impede que marcadores de PR herdados ativem o recorder em produção/HML.
  return (
    process.env.NODE_ENV === 'production' &&
    ['pr.uticket.dev.br', 'pr2.uticket.dev.br', 'pr3.uticket.dev.br'].includes(hostname) &&
    /^[1-9]\d*$/.test(process.env.REACT_APP_PR_NUMBER || '')
  );
}

/**
 * Verifica se a exportação automática local para o dev-server (.backtrack/) está habilitada.
 * Requer Backtrack habilitado, ambiente estritamente de desenvolvimento e flag ativa.
 */
export function isBacktrackLocalExportEnabled(): boolean {
  return (
    isBacktrackEnabled() &&
    process.env.NODE_ENV === 'development' &&
    typeof window !== 'undefined' &&
    ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname) &&
    process.env.REACT_APP_BACKTRACK_LOCAL_EXPORT === 'true'
  );
}
